import { useRoutes } from 'react-router-dom'

import InvitationRoutes from './InitationRoutes'
import LoginRoutes from './LoginRoutes'
import MainRoutes from './MainRoutes'
import SubscriptionRoutes from './SubscriptionRoutes'

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([
    LoginRoutes,
    MainRoutes,
    InvitationRoutes,
    SubscriptionRoutes,
  ])
}
